import { GeminiViewManager } from './GeminiViewManager';

class OrbitManager {
    config = {};
    hotspotItems = {};
    zoneItems = {};
    scenes = [];
    onSceneChanged = undefined;
    onShiftRightClick = undefined;
    onRightClick = undefined;
    viewer = undefined;
    data = undefined;
    autorotateToggleElement = undefined;
    disableClick = true;
    panoElement = undefined;
    viewerIRef = undefined;

    constructor(props) {
        this.config = props.config;
        this.initialZoneId = props.initialZoneId;
        this.hotspotItems = props.hotspotItems;
        this.zoneItems = props.zoneItems;
        this.onSceneChanged = props.onSceneChanged;
        this.onShiftRightClick = props.onShiftRightClick;
        this.onRightClick = props.onRightClick;
        this.viewerRef = props.viewerRef;
        window.geminiViewManager = new GeminiViewManager(this);
    }

    init() {
        this.data = this.config.data;
    }

    update(props) {
        this.config = props.config;
        this.initialZoneId = props.initialZoneId;
        this.hotspotItems = props.hotspotItems;
        this.zoneItems = props.zoneItems;
        this.onSceneChanged = props.onSceneChanged;
        this.onShiftRightClick = props.onShiftRightClick;
        this.onRightClick = props.onRightClick;
        this.viewerRef = props.viewerRef;
        window.geminiViewManager = new GeminiViewManager(this);
        this.data = this.config.data;
    }

    switchSceneById(sceneId) {
        this.onSceneChanged({ data: { id: sceneId } });
    }
    updateView() {}
    disableControls() {}
    enableControls() {}
    screenToCoordinates(coord) {
        if (this.viewerRef.current) {
            return this.viewerRef.current.viewCoordToImageCoord(coord);
        } else {
            return null;
        }
    }
    deleteView() {}
    getCurrentViewParams() {
        try {
            const viewer = this.viewerRef?.current;
            const imageElement = viewer?.getViewerImageRef?.()?.current;
            if (viewer && imageElement) {
                const bounds = imageElement.getBoundingClientRect();
                const coordinates = viewer.viewCoordToImageCoord({
                    x: bounds.left + bounds.width / 2,
                    y: bounds.top + bounds.height / 2,
                });
                const animatedValues = viewer.getAnimatedValues();
                return {
                    init_view_flat_x: Number.parseFloat(coordinates.x),
                    init_view_flat_y: Number.parseFloat(coordinates.y),
                    zoom: animatedValues?.current?.zoom?._value ?? 1,
                };
            }
        } catch (_) {}
        return { init_view_flat_x: 0.5, init_view_flat_y: 0.5, zoom: 1 };
    }
    setViewParams(params) {
        this.viewerRef?.current?.setViewParams?.(params);
    }
    getCurrentViewImage() {
        return null;
    }
    setSceneInitView() {}
    resetInitialView() {}
    updateViewParamsFromZone() {}
}

export { OrbitManager };
